import type { CookieSerializeOptions } from 'cookie-es'

export const ACCESS_TOKEN = 'yescapaAPI_access_token'
export const REFRESH_ACCESS_TOKEN = 'yescapaAPI_refresh_token'
export const REFRESH_ACCESS_TOKEN_VALIDITY = 60 * 60 * 24 * 30 // 30 days seen with Claire R

export const defaultCookieOptions: CookieSerializeOptions = {
  path: '/',
  secure: true,
  sameSite: 'lax',
}
